module.exports = __webpack_public_path__ + "img/two.d379c082.png";